import hmacsha1 from "hmacsha1";
import { Base64 } from "js-base64";

interface Params {
  [key: string]: any;
}
export function useGetSign(params: object) {
  let currentParams: Params = params;
  let result = [];
  let name = [];

  // 获取键名
  for (let key in currentParams) {
    if (key != undefined && key != "sign") {
      name.push(key);
    }
  }
  // 键名排序
  name.sort();

  for (let i = 0; i < name.length; i++) {
    let key = name[i];
    let value = currentParams[key];
    if (value != undefined || value != null) {
      result.push(key + "=" + value);
    }
  }

  let strResult = result.join("&");
  let secret = "mSUlWvWRtijX6AwqVF1hXAx843GUYxMt";



  let seRes = strResult;

  let baseResult = Base64.encode(seRes);



  let shaResult = hmacsha1(secret, baseResult);



  currentParams.sign = shaResult.toLowerCase();

  return currentParams;
}
